import type { SVGProps } from "react";
export interface BowlNoodleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function BowlNoodleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: BowlNoodleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M5.921 1.536a1.126 1.126 0 0 1 1.27 1.851l.01-.007.002-.002-.034.037a.2.2 0 0 0-.042.076l.065.09c.033.04.08.093.148.17.22.247.785.827.786 1.748 0 .652-.318 1.162-.559 1.474l-.2.245a6 6 0 0 0-.156.192 1 1 0 0 0-.07.1c.03.045.08.107.2.24.218.247.784.828.785 1.75 0 .418-.126.766-.274 1.039l-.06.098A1.125 1.125 0 0 1 5.859 9.49a2 2 0 0 0-.199-.242c-.209-.234-.733-.774-.78-1.624H3a1.125 1.125 0 0 1 0-2.25h2.77l-.11-.126c-.124-.14-.358-.39-.539-.747l-2.055.122a1.126 1.126 0 0 1-.132-2.246l2.313-.136a2.6 2.6 0 0 1 .517-.594L5.8 1.62l.015-.01.006-.005.003-.002h.001V1.6l.097-.064Zm4.945 9.181a1.125 1.125 0 0 1-1.733-1.434zm-1.54-9.616a1.125 1.125 0 1 1 1.348 1.797l.002.001.001-.001.003-.002q.003-.001.005-.004l.007-.006.01-.007-.001.001a.4.4 0 0 0-.041.047.2.2 0 0 0-.033.065c.028.047.075.105.213.259.219.246.785.827.785 1.749 0 .869-.565 1.482-.759 1.717-.133.161-.197.25-.225.293.03.044.079.107.199.241.219.246.785.827.785 1.75 0 .868-.565 1.482-.759 1.716L10.001 10l-.868-.716c.065-.078.113-.136.156-.192q.048-.065.068-.102a2 2 0 0 0-.197-.24c-.206-.23-.715-.756-.778-1.58L8.375 7l.007-.16c.063-.783.57-1.337.751-1.556a3 3 0 0 0 .224-.296 3 3 0 0 0-.197-.239c-.22-.246-.785-.826-.785-1.748 0-.622.25-1.1.465-1.396a2.6 2.6 0 0 1 .456-.481l.016-.014.007-.004.005-.004.451.6zM20.5 5.375l.115.006a1.126 1.126 0 0 1 0 2.238l-.114.006h-6.213a1.125 1.125 0 0 1 0-2.25zm-.566-3.998a1.125 1.125 0 1 1 .131 2.246l-6 .353-.114.002a1.125 1.125 0 0 1-.017-2.248z"
      />
      <path
        fill={color}
        d="M21.506 8.875c.834 0 1.546.639 1.614 1.48l.005.17c-.043 1.853-.31 3.45-.841 4.732a11.1 11.1 0 0 1-2.414 3.61 11.1 11.1 0 0 1-2.916 2.09V21a2.126 2.126 0 0 1-2.125 2.125H9.172A2.126 2.126 0 0 1 7.046 21v-.041a11.1 11.1 0 0 1-2.916-2.092 11.1 11.1 0 0 1-2.192-3.109l-.22-.5c-.466-1.123-.73-2.485-.817-4.05l-.026-.682a1.62 1.62 0 0 1 1.62-1.651zM3.15 11.125c.08 1.375.308 2.457.645 3.271a8.88 8.88 0 0 0 4.806 4.803c.42.174.694.585.694 1.04v.636h5.409v-.636c0-.455.273-.866.694-1.04a8.88 8.88 0 0 0 4.806-4.803c.337-.814.564-1.896.643-3.271z"
      />
    </svg>
  );
}
